import * as angular from 'angular';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { AppComponent } from '../src/app/app.component';
import { DatePickerComponent } from '../src/app/shared/components/date-picker/date-picker.component';
import { DatetimePickerComponent } from '../src/app/shared/components/datetime-picker/datetime-picker.component';
import { TreeViewComponent } from '../src/app/shared/components/tree-view/tree-view.component';
import { TrainTreeStructureComponent } from '../src/app/features/monitoring/components/train-tree-structure/train-tree-structure.component';
import { SimOperatorTreeViewComponent } from '../src/app/features/sims/components/sim-operator-tree-view/sim-operator-tree-view.component';
import { NavBarComponent } from '../src/app/layout/components/nav-bar/nav-bar.component';
import { FooterComponent } from '../src/app/layout/components/footer/footer.component';
import { TranslateService } from '@ngx-translate/core';
import { MonitoringBehaviorSubjectService } from '../src/app/features/monitoring/services/monitoring-behavior-subject.service';
import { UserDataService } from '../src/app/features/users/services/user-data.service';
import { AnalysisInformationComponent } from '../src/app/features/analysis/components/analysis-information/analysis-information.component';
import { ProjectConfigurationBehaviorSubjectService } from '../src/app/features/project/services/project-configuration-behavior-subject.service';
import { MonitoredTrainsTilesComponent } from '../src/app/features/monitoring/components/monitored-trains-tiles/monitored-trains-tiles.component';
import { MonitoredTrainsTableComponent } from '../src/app/features/monitoring/components/monitored-trains-table/monitored-trains-table.component';
import { MonitoredTrainAlarmsComponent } from '../src/app/features/monitoring/components/monitored-train-alarms/monitored-train-alarms.component';
import { SimListComponent } from '../src/app/features/sims/components/sim-list/sim-list.component';
import { ToastBehaviorSubjectService } from '../src/app/shared/services/toast-behavior-subject.service';
import { MonitoredTrainsMapComponent } from '../src/app/features/monitoring/components/monitored-trains-map/monitored-trains-map.component';
import { MenuBehaviorSubjectService } from '../src/app/shared/services/menu-behavior-subject.service';

export const downgradedAngularModule = angular.module('noc.angular', [
])

// Components downgraded to directives
downgradedAngularModule.directive('appRoot', downgradeComponent({component: AppComponent}) as angular.IDirectiveFactory);
downgradedAngularModule.directive('appNavBar', downgradeComponent({
    component: NavBarComponent,
    inputs: ['selectedProject', 'currentUser', 'currentTimezone'],
    outputs: ['home', 'logout', 'changeMetric', 'changeLanguage', 'changeCurrency', 'changeTimezone', 'changeLocale', 'clearFilters']
}) as angular.IDirectiveFactory);
downgradedAngularModule.directive('appFooter', downgradeComponent({
    component: FooterComponent,
    inputs: ['isAdmin']
}) as angular.IDirectiveFactory);
downgradedAngularModule.directive('appDatePicker', downgradeComponent({
    component: DatePickerComponent,
    inputs: ['date', 'maxDate', 'minDate'],
    outputs: ['change']
}) as angular.IDirectiveFactory);
downgradedAngularModule.directive('appDatetimePicker', downgradeComponent({
    component: DatetimePickerComponent,
    inputs: ['dateTime', 'maxDateTime', 'minDateTime', 'isInputTimestamp'],
    outputs: ['change']
}) as angular.IDirectiveFactory);
downgradedAngularModule.directive('appTreeView', downgradeComponent({
    component: TreeViewComponent,
    inputs: [],
    outputs: []
}) as angular.IDirectiveFactory);
downgradedAngularModule.directive('appTrainTreeStructure', downgradeComponent({
    component: TrainTreeStructureComponent,
    inputs: ['structure'],
    outputs: ['select']
}) as angular.IDirectiveFactory);
downgradedAngularModule.directive('appSimOperatorTreeView', downgradeComponent({
    component: SimOperatorTreeViewComponent,
    inputs: ['operators'],
    outputs: ['select']
}) as angular.IDirectiveFactory);

downgradedAngularModule.directive('appAnalysisInformation', downgradeComponent({
    component: AnalysisInformationComponent,
    inputs: [],
    outputs: ['reloadPeriod', 'changeTrip']
}) as angular.IDirectiveFactory);

downgradedAngularModule.directive('appMonitoredTrainsTiles', downgradeComponent({
    component: MonitoredTrainsTilesComponent,
    inputs: ['monitoredTrains', 'projectId'],
    outputs: ['investigateTrain']
}) as angular.IDirectiveFactory);

downgradedAngularModule.directive('appMonitoredTrainsTable', downgradeComponent({
    component: MonitoredTrainsTableComponent,
    inputs: ['monitoredTrains', 'projectId', 'isSingleTrain', 'isIntegratedConsole'],
    outputs: ['investigateTrain', 'rightClick']
}) as angular.IDirectiveFactory);

downgradedAngularModule.directive('appMonitoredTrainsMap', downgradeComponent({
    component: MonitoredTrainsMapComponent,
    inputs: ['trains', 'zoom', 'isSingleTrain']
}) as angular.IDirectiveFactory);


downgradedAngularModule.directive('appMonitoredTrainAlarms', downgradeComponent({
    component: MonitoredTrainAlarmsComponent,
    inputs: ['alarms', 'projectId', 'isSingleTrain'],
    outputs: ['investigateTrain', 'acknowledgeAlarm', 'investigateAlarm', 'raiseIncident']
}) as angular.IDirectiveFactory);

downgradedAngularModule.directive('appSimList', downgradeComponent({
    component: SimListComponent,
    inputs: ['sims', 'isConfiguration', 'isOverview'],
    outputs: []
}) as angular.IDirectiveFactory);


// Services downgraded to factories
downgradedAngularModule.factory('translateService', downgradeInjectable(TranslateService) as any);
downgradedAngularModule.factory('monitoringBehaviorSubjectService', downgradeInjectable(MonitoringBehaviorSubjectService) as any);
downgradedAngularModule.factory('menuBehaviorSubjectService', downgradeInjectable(MenuBehaviorSubjectService) as any);
downgradedAngularModule.factory('UserFactory', downgradeInjectable(UserDataService) as any);
downgradedAngularModule.factory('projectConfigurationBehaviorSubjectService', downgradeInjectable(ProjectConfigurationBehaviorSubjectService) as any);
downgradedAngularModule.factory('toastBehaviorSubjectService', downgradeInjectable(ToastBehaviorSubjectService) as any);